import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name"];
import { Input } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Username = props => {
  var {
      keyname = 'username',
      name
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var nameBase = name || keyname;
  var key = keyname || name;
  return /*#__PURE__*/_jsx(Input, _extends({
    placeholder: "Username",
    spellCheck: false
  }, elmProps, {
    name: nameBase,
    keyname: key
  }));
};
Username.displayName = 'BaseLogin.Username';